import SecurityView from "../SecurityView.vue"
import LoginPage from "../Pages/LoginPage.vue"
import LoginCallback from "../Pages/LoginCallback.vue"
import SSOErrorPage from "../Pages/SSOErrorPage.vue"

const routes = [
    {
        path: '/login',
        component: SecurityView,
        children: [
            {
                path: '',
                name: 'login-page',
                component: LoginPage,
            },
        ]
    },
    {
        path: '/callback',
        component: SecurityView,
        children: [
            {
                path: '',
                name: 'callback-page',
                component: LoginCallback,
            },
        ]
    },
    {
        path: '/sso-error',
        component: SecurityView,
        children: [
            {
                path: '',
                name: 'sso-error-page',
                component: SSOErrorPage,
            },
        ]
    },
]

export default routes
